import {Action} from "@ngrx/store";
import {Product} from "../../websites/website/product";
import {Website} from "../../websites/website/website";

export const LOAD_WEBSITE_PRODUCTS: string = '[webstieProduct] Load Website Products';
export const LOAD_WEBSITE_PRODUCTS_SUCCESS: string = '[webstieProduct] Load Website Products Success';
export const LOAD_WEBSITE_PRODUCTS_FAIL: string = '[webstieProduct] Load Website Products Fail';
export const INIT_WEBSITE_PRODUCT_ACTION: string = '[webstieProduct] Init Website Product Action';
export const INIT_WEBSITE_PRODUCT_UPLOAD_ACTION: string = '[webstieProduct] Init Website Product Upload Action';
export const UPDATE_WEBSITE_PRODUCT_STATE: string = '[webstieProduct] Update Website Product State';
export const DELETE_WEBSITE_PRODUCT: string = '[webstieProduct] Delete Website Product';

export class LoadWebsiteProducts implements Action {

  readonly type: string = LOAD_WEBSITE_PRODUCTS;
  constructor(public payload: number, public isChildWebsite?: boolean|null) {}

}

export class LoadWebsiteProductsSuccess implements Action {

  readonly type: string = LOAD_WEBSITE_PRODUCTS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    pluginEntities: {[slug: string]: any},
    extensionEntities: {[slug: string]: any},
    themeEntities: {[slug: string]: any},
    isChildWebsite?: boolean|null
  }) {}

}

export class LoadWebsiteProductsFail implements Action {

  readonly type: string = LOAD_WEBSITE_PRODUCTS_FAIL;
  constructor(public payload: string, public isChildWebsite?: boolean|null) {}

}

export class InitWebsiteProductAction implements Action {

  readonly type: string = INIT_WEBSITE_PRODUCT_ACTION;
  constructor(public payload: {
    website: any,
    products: Product[],
    action: string,
    network?: number
  }) {}

}

export class InitWebsiteProductUploadAction implements Action {

  readonly type: string = INIT_WEBSITE_PRODUCT_UPLOAD_ACTION;
  constructor(public payload: {
    website: Website,
    products: Product[],
    action: string,
    network?: number
  }) {}

}

export class UpdateWebsiteProductState implements Action {

  readonly type: string = UPDATE_WEBSITE_PRODUCT_STATE;
  constructor(public payload: any) {}

}

export class DeleteWebsiteProduct implements Action {

  readonly type: string = DELETE_WEBSITE_PRODUCT;
  constructor(public payload: any) {}

}

export type WebsiteProductAction = LoadWebsiteProducts | LoadWebsiteProductsSuccess | LoadWebsiteProductsFail
  | InitWebsiteProductAction | InitWebsiteProductUploadAction | UpdateWebsiteProductState | DeleteWebsiteProduct;
